class BlueButton extends Button {
    constructor(oldContainer: JQuery, controller: Controller, mode: string) {
        super(oldContainer.attr("id"), controller, oldContainer, mode);
    }

    initHTML(oldContainer: JQuery) {
        var label = oldContainer.html();
        var classes = oldContainer.attr("class");

        var newHTML = '<div class="button ' + classes + '" id="' + this.identifier + '_blue">' + label + '</div>';

        this.container = $(newHTML);

        oldContainer.replaceWith(this.container);
    }

    setEnabled(enabled) {
        this.container.toggleClass("disabled", !enabled);
    }

    isEnabled(): boolean {
        return !this.container.hasClass("disabled");
    }

    previewEnabled(enabled) {
        if (enabled && this.container.hasClass("disabled")) {
            this.container.addClass("feedforward_enabled");
        } else if (!enabled && !this.container.hasClass("disabled")) {
            this.container.addClass("feedforward_disabled");
        }
    }

    removePreviewState() {
        this.container.removeClass("feedforward_enabled feedforward_disabled");
    }

    removePreviewEnabled() {
    }
}